// Timeout constants for success-state auto-dismissal (ms).
export const VALUATION_RESET_MS = 3000;
export const CONTACT_RESET_MS = 3000;

// Jess's "About Me" copy (verbatim from Jess). Shared by the homepage About section and every landing page bio.
export const ABOUT_ME_PARAGRAPHS = [
  'Born on the lawn of Virginia Beach and raised in the Outer Banks, I know these coastal communities inside and out. Today, I\u2019m proud to raise my daughter in Virginia Beach while taking every opportunity to unwind in my OBX hometown.',
  'I love helping my clients navigate these beautiful, wildly diverse coastal communities. As a licensed boat captain and member of Freedom Boat Club, I offer a unique personalized experience for select waterfront listings, I can even schedule to show you homes by boat!',
];
export const ABOUT_ME_CLOSER = 'For an expert who takes pride in a truly personalized experience CALL JESS & FORGET THE REST!';
export const BLOG_SUBSCRIBE_RESET_MS = 4000;
export const GUIDE_RESET_MS = 3000;

// Site-wide constants & static content for the Jessica Burnette real-estate site.

export const IDX_BASE_URL =
  'https://search.sellwithswell.com/idx/agent/15892256/jessica-burnette';
// IDX Broker consumer account portal (save searches, favorites, listing alerts).
export const IDX_SEARCH_URL = 'https://search.sellwithswell.com/idx/search/advanced';
export const IDX_MAP_SEARCH_URL = 'https://search.sellwithswell.com/idx/map/mapsearch';
export const IDX_LOGIN_URL = 'https://search.sellwithswell.com/idx/userlogin';
export const IDX_SIGNUP_URL = 'https://search.sellwithswell.com/idx/usersignup';

// Third-party URLs intentionally hardcoded: these are Jessica's permanent
// account-specific links and are identical across preview and production.
export const MLS_BUYER_PORTAL_URL = 'https://mls-client.com/76513B10';
export const SORO_EMBED_SRC =
  'https://app.trysoro.com/api/embed/478d1212-3e29-4d05-b744-c65f2dac3319';

export const PHONE_NUMBER = '252-564-5612';
export const PHONE_TEL_HREF = 'tel:252-564-5612';
export const EMAIL_ADDRESS = 'jess@jesssellseastcoast.com';
export const SMS_HREF = 'sms:252-564-5612';
// Jess's public Google Calendar appointment link (used by the AI chat hand-off).
export const BOOKING_URL = 'https://calendar.app.google/ZvykdcSLm7CbtccN9';

// Local WebP-optimized images (served from /public/img). ~60% smaller than originals.
export const LOGO = '/img/logo.webp';
export const JESSICA_PHOTO = '/img/jessica-beach.webp';
export const HERO_BG = '/img/hero.webp';
export const PROPERTY_1 = '/img/property1.webp';
export const PROPERTY_2 = '/img/property2.webp';

// "As Seen on TV" feature video (YouTube privacy-enhanced embed).
export const ABOUT_TV_VIDEO_URL = 'https://www.youtube-nocookie.com/embed/1DYjDJviqfY';

// Relocation guide copy keyed by area — replaces nested ternaries in JSX.
export const RELOCATION_GUIDE_COPY = {
  hampton_roads: {
    title: 'Hampton Roads',
    subtitle:
      'Your complete guide to relocating to Virginia Beach, Norfolk & Hampton Roads',
  },
  outer_banks: {
    title: 'Outer Banks',
    subtitle: 'Your complete guide to relocating to the Outer Banks, NC',
  },
  both: {
    title: 'Coastal VA & NC',
    subtitle:
      'Your complete guides to relocating to Hampton Roads & the Outer Banks',
  },
};
export const getRelocationCopy = (area) =>
  RELOCATION_GUIDE_COPY[area] || RELOCATION_GUIDE_COPY.both;

export const TESTIMONIALS = [
  {
    initials: 'MH',
    name: 'Manuel Hurtarte',
    time: '6 weeks ago',
    badge: 'Google • Local Guide • 61 reviews',
    text: "I had an exceptional experience working with Jess. From start to finish, she is very professional, knowledgeable, and incredibly supportive throughout the entire process. She communicated clearly, answered every question promptly, and always made sure I felt informed and confident in each step. What stood out most was her attention to detail and genuine commitment to finding the right home for me. She went above and beyond—whether it was scheduling showings quickly, offering thoughtful guidance, or negotiating effectively on my behalf. Thank you for your expertise and dedication, the process was not easy but it made it easier having you helping me and my family. I couldn't be happier with the outcome and highly recommend Jessica to anyone looking to buy or sell a home.",
  },
  {
    initials: 'MT',
    name: 'Michael Tolbert',
    time: '21 weeks ago',
    badge: 'Google',
    text: 'Jessica is the best realtor. She walked with me every step of the way on buying a home. Very knowledgeable and great communication. I highly recommend! She also helped me save a lot of money and time!!!!',
  },
  {
    initials: 'TC',
    name: 'Thomas Corbett',
    time: '29 weeks ago',
    badge: 'Google',
    text: "Working with Jess was great, she brokered us a nice deal where the sellers covered the realtors fee so we didn't have to pay out of pocket. She worked hard showing us many houses, were very grateful!",
  },
  {
    initials: 'DG',
    name: 'Damon Gilbert',
    time: '51 weeks ago',
    badge: 'Google',
    text: 'Jessica was very thorough and thoughtful. Was on time with everything!! She would be the one I would use every time!!',
  },
  {
    initials: 'TM',
    name: 'Trevon Morris',
    time: 'Dec 19, 2024',
    badge: 'Google • 6 reviews',
    text: "Jessica is Legit. She knows her stuff for real. What normally is a long drawn out terrible process was made easy in literally 3 months and that's with the actual house search btw I couldn't be more grateful for my new home and for her as a realtor. She went out of her way to help me.",
  },
];

export const SERVICE_AREAS = [
  'Virginia Beach, VA',
  'Great Neck & Little Neck',
  'Sandbridge & Croatan',
  'North End & Bay Colony',
  'Norfolk & Chesapeake, VA',
  'Suffolk & Portsmouth, VA',
  'Williamsburg, VA',
  'Outer Banks, NC',
  'Corolla & Duck, NC',
  'Southern Shores & Kitty Hawk, NC',
  'Kill Devil Hills & Nags Head, NC',
  'Currituck & Elizabeth City, NC',
];
